import React, { FunctionComponent, useState } from "react";
import { ProductParentCategory } from "@/models/scope/productSheet/ProductParentCategory";
import { MetaInfos } from "@/models/scope/productSheet/MetaInfos";
import { SEO_URL_PARAM_NAME } from "@/utils/constants"

interface Props {
    category: {
        id: string;
        label: string;
        metaInfos: MetaInfos;
        parentsCategories: ProductParentCategory[];
    };
}
export const Breadcrumb: FunctionComponent<Props> = ({ category }) => {
    const [isBreadcrumbComplete, setIsBreadcrumbComplete] = useState(false);

    function areAllLabelsNull(category: { parentsCategories: { label: string | null }[] }): boolean {
        return category.parentsCategories.every(categoryItem => categoryItem.label !== null);
    }
    return (
        <p className="breadcrumb-product small">
            <a href="/"><span className="home" /></a>
            {areAllLabelsNull(category) && (
                <span className={isBreadcrumbComplete ? "hide" : "dots"}
                      onClick={() => setIsBreadcrumbComplete(true)}>...</span>
            )}
            {category.parentsCategories.map((categoryItem, i) => {
                return (
                    !!categoryItem.label && <a key={categoryItem.id}
                                               href={categoryItem.metaInfos.items.find((c) => c.code === SEO_URL_PARAM_NAME)?.value}>
                        <span className={(isBreadcrumbComplete ? "parent" : "hide")}>
                            {categoryItem.label}
                        </span>
                    </a>)
            })}
            {!!category.label &&
                <a key={category.id} href={category.metaInfos.items.find((c) => c.code === SEO_URL_PARAM_NAME)?.value}>
                <span className={"last-parent"}>
                    {category.label}
                </span>
                </a>
            }
        </p>
    )
}
